module.exports = __webpack_public_path__ + "img/icon (25).b4f3e711.png";